import { render, staticRenderFns } from "./SearchGroupItem.vue?vue&type=template&id=17adc57a"
import script from "./SearchGroupItem.vue?vue&type=script&lang=js"
export * from "./SearchGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports